__turbopack_context__.v({
  "awards": "W9qrmq_awards",
});
